"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = blobToArrayBuffer;

function blobToArrayBuffer(file) {
  return new Promise(function (resolve, reject) {
    var reader = new FileReader();

    reader.onerror = function (_ref) {
      var error = _ref.error,
          message = _ref.message;
      return reject(error || new Error(message));
    };

    reader.onloadend = function () {
      return resolve(reader.result);
    };

    reader.readAsArrayBuffer(file);
  });
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9VdGlscy9kb3duc2NhbGVJbWFnZVRvRGF0YVVSTC9ibG9iVG9BcnJheUJ1ZmZlci5qcyJdLCJuYW1lcyI6WyJibG9iVG9BcnJheUJ1ZmZlciIsImZpbGUiLCJQcm9taXNlIiwicmVzb2x2ZSIsInJlamVjdCIsInJlYWRlciIsIkZpbGVSZWFkZXIiLCJvbmVycm9yIiwiZXJyb3IiLCJtZXNzYWdlIiwiRXJyb3IiLCJvbmxvYWRlbmQiLCJyZXN1bHQiLCJyZWFkQXNBcnJheUJ1ZmZlciJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUFlLFNBQVNBLGlCQUFULENBQTJCQyxJQUEzQixFQUFpQztBQUM5QyxTQUFPLElBQUlDLE9BQUosQ0FBWSxVQUFDQyxPQUFELEVBQVVDLE1BQVYsRUFBcUI7QUFDdEMsUUFBTUMsTUFBTSxHQUFHLElBQUlDLFVBQUosRUFBZjs7QUFFQUQsSUFBQUEsTUFBTSxDQUFDRSxPQUFQLEdBQWlCO0FBQUEsVUFBR0MsS0FBSCxRQUFHQSxLQUFIO0FBQUEsVUFBVUMsT0FBVixRQUFVQSxPQUFWO0FBQUEsYUFBd0JMLE1BQU0sQ0FBQ0ksS0FBSyxJQUFJLElBQUlFLEtBQUosQ0FBVUQsT0FBVixDQUFWLENBQTlCO0FBQUEsS0FBakI7O0FBQ0FKLElBQUFBLE1BQU0sQ0FBQ00sU0FBUCxHQUFtQjtBQUFBLGFBQU1SLE9BQU8sQ0FBQ0UsTUFBTSxDQUFDTyxNQUFSLENBQWI7QUFBQSxLQUFuQjs7QUFDQVAsSUFBQUEsTUFBTSxDQUFDUSxpQkFBUCxDQUF5QlosSUFBekI7QUFDRCxHQU5NLENBQVA7QUFPRCIsInNvdXJjZVJvb3QiOiJjb21wb25lbnQ6Ly8vIiwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gYmxvYlRvQXJyYXlCdWZmZXIoZmlsZSkge1xuICByZXR1cm4gbmV3IFByb21pc2UoKHJlc29sdmUsIHJlamVjdCkgPT4ge1xuICAgIGNvbnN0IHJlYWRlciA9IG5ldyBGaWxlUmVhZGVyKCk7XG5cbiAgICByZWFkZXIub25lcnJvciA9ICh7IGVycm9yLCBtZXNzYWdlIH0pID0+IHJlamVjdChlcnJvciB8fCBuZXcgRXJyb3IobWVzc2FnZSkpO1xuICAgIHJlYWRlci5vbmxvYWRlbmQgPSAoKSA9PiByZXNvbHZlKHJlYWRlci5yZXN1bHQpO1xuICAgIHJlYWRlci5yZWFkQXNBcnJheUJ1ZmZlcihmaWxlKTtcbiAgfSk7XG59XG4iXX0=